import { render, staticRenderFns } from "./gsTable.vue?vue&type=template&id=ded54aee&"
import script from "./gsTable.vue?vue&type=script&lang=js&"
export * from "./gsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports